export const PERIOD_FILTER_OPTIONS = [
  {
    label: '전체',
    value: 999,
  },
  {
    label: '1년',
    value: 365,
  },
  {
    label: '6개월',
    value: 180,
  },
  {
    label: '1개월',
    value: 30,
  },
  {
    label: '1주일',
    value: 7,
  },
  {
    label: '오늘',
    value: 0,
  },
];
